// extracted by mini-css-extract-plugin
module.exports = {"link":"example-link-module--link--2yj8u"};